exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg{color:red;font-size:14px}h1{font-size:3em!important}.input,.mt-3.mb-3{font-size:1.5em!important}.remember{height:10px;width:200px;vertical-align:middle}.card-logo{position:absolute;top:10px;right:10px}body{background-color:#3d8cbc!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/login/FormLogin.vue?vue&type=style&index=1&id=4ea57bb5&prod&lang=css&
// module id = 879
// module chunks = 0